import React from 'react'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'
import { jobListHeadings1 } from '../Data/StaticData'
import { ToastContainer, toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import _ from 'lodash'
import AwsConfig from '../../Config/AwsConfig'
import GetContentsList from '../../Services/Queries/GetContentsList'
import PublishContent2Point0 from '../../Services/Mutations/PublishContent2Point0'
import DeleteContent from '../../Services/Mutations/DeleteContent'
import DeleteContentInSingleLanguage from '../../Services/Mutations/DeleteContentInSingleLanguage'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import { Button, Modal, Table } from 'react-bootstrap'
import ReactReadMoreReadLess from 'react-read-more-read-less'
import Header from '../header'
import Spinner from '../header/Spinner'
import { Auth } from 'aws-amplify'
import GetContent from '../../Services/Queries/GetContent'
import SearchJobs from '../../Services/Queries/SearchJobs.js'
import { searchJobs } from '../../Graphql/queries'
import GetListJobs from '../../Services/Queries/GetListJobs'






class activeJobs extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			activeJobsList: [],
			headings: jobListHeadings1,
			appLanguage: '',
			filtered: false,
			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: 'selection',
			},
			showDatePicker: false,
			limit: 10,
			loggedInUserPermissions: [],
			loading: false,
			selectedContentId: '',
			approveModalVisible: false,
			deleteModalVisible: false,
			selectedContentLanguages: [],
			filtered: false,
			searchQuery: '',
			jobLists: '',
			search: " ",
			searched: false,
			expiredJobs: false,
			render: false,
			from: 0,
			totalSearchResultsCount: 0,
			nextToken: null,
			selectedFilterType: '',
			contentsTypes: [
				'latestPostedJobs',
				'relevance',
				//'Salary high to low'
			],
			filteredExperienceRange: [],
			filteredJobCategories: [],
			filteredJobMainLocations: [],
			filteredJobQualifications: [],
			filteredJobRoles: [],
			filteredJobSkills: [],
			filteredJobSubLocations: [],
			filteredJobTypes: [],
			filteredSalaryRange: [],
			filteredWorkTypes: [],
			initialFromValue: 0,
			initialLoadMore: true,



		}
		this.contentImage = ''
		this.contentImages = []
		this.contentStatus = ''
		this.isPreviouslyCampaign = false
		this.InAppMessageChild = React.createRef()
		this.isPreviouslyStickyPost = false
		this.missingMandatoryFields = true
		this.missingSubContentMandatoryFields = true
		this.job = {}

		this.loadMore = this.loadMore.bind(this)

	}
	changeAppLanguage = async (e) => {
		const { appLanguage } = this.state
		//  console.log(e, 'eeeeeeeeeee')
		//  console.log(e.target.value, 'e.target.value')
		const language = e.target.value
		if (language && appLanguage != language) {
			this.setState({ appLanguage: language }, async () => {
				//  console.log('in list pn counterssssss')
				await this.getActiveJobsList()
			})
			localStorage.setItem("appLanguage", language);
		}

	}
	componentDidMount = async () => {
		let appLanguage = localStorage.getItem('appLanguage')
		appLanguage = appLanguage ? appLanguage : "Telugu"
		//  console.log(appLanguage, 'appLanguage')
		this.setState({ appLanguage: appLanguage }, async () => {
			await this.getActiveJobsList()
		})
	}
	renderDeleteConfirmationModal = () => {
		const { deleteModalVisible, selectedContentLanguages } = this.state
		return (
			<Modal show={deleteModalVisible} onHide={() => this.closeDeleteModal()}>
				<Modal.Body>
					<div>
						{this.state.selectedContentId.contentLanguages &&
							this.state.selectedContentId.contentLanguages.length > 1 &&
							this.state.selectedContentId.contentLanguages.map((language) => {
								let lang
								if (language == 'En') {
									lang = 'English'
								} else {
									lang = 'Telugu'
								}
								return (
									<div class='row'>
										<div class='col-md-1'>
											<input
												type='checkbox'
												onClick={() => this.handleLanguage(lang)}
												checked={selectedContentLanguages.includes(lang)}
											></input>
										</div>
										<div class='col-md-8'>
											<text for='text'> {lang} </text>
										</div>
									</div>
								)
							})}
					</div>
					<div className='row'>
						<text>Are you sure you want to delete this Job?</text>
					</div>
					{/* {console.log(this.state.selectedContentId, 'this is the lang')} */}
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeDeleteModal()}>Cancel</Button>
					{(this.state.selectedContentId &&
						this.state.selectedContentId.contentLanguages.length == 1) ||
						this.state.selectedContentLanguages.length > 0 ? (
						<Button onClick={() => this.handleDelete()}>Ok</Button>
					) : (
						<Button disabled variant='secondary'>
							Ok
						</Button>
					)}
				</Modal.Footer>
			</Modal>
		)
	}
	handleDelete = async () => {
		//  console.log(this.state.selectedContentLanguages, 'selectedContentLanguages')
		//  console.log(this.state.selectedContentId.contentLanguages, 'selectedContentId.contentLanguages')
		const item = this.state.selectedContentId
		this.setState({ deleteModalVisible: false })

		if (
			this.state.selectedContentId.contentLanguages.length == 1 ||
			this.state.selectedContentId.contentLanguages.length ==
			this.state.selectedContentLanguages.length
		) {
			const input = { contentID: item.PK }
			// console.log(input, 'input')
			const data = await DeleteContent(input)
			// console.log(data, 'this is the status code')

			if (data.statusCode == 'A185') {
				const refreshContentsList = this.state.activeJobsList.filter((data) => {
					return data.PK !== item.PK
				})

				this.setState({ activeJobsList: refreshContentsList })
				toast.success('Job Deleted Successfully', this.toastStyle)
			} else {
				toast.error('Failed to delete Job', this.toastStyle)
			}
		}
		else {
			const input = { contentID: item.PK, language: this.state.selectedContentLanguages[0] }
			//  console.log(input, 'inputDeleteContentInSingleLanguage')

			const data = await DeleteContentInSingleLanguage(input)
			//  console.log(data, 'datadata')
			if (data.statusCode == 'A296') {
				const index = this.state.activeJobsList.findIndex((data) => data.PK == item.PK)
				let deletedLang
				if (this.state.selectedContentLanguages[0] == 'English') {
					deletedLang = 'En'
				} else {
					deletedLang = 'Te'
				}
				let selectedIdContentLangs = this.state.activeJobsList[index].contentLanguages
				selectedIdContentLangs = selectedIdContentLangs.filter((lang) => lang !== deletedLang)

				this.state.activeJobsList[
					index
				].contentLanguages = this.state.activeJobsList[index].contentLanguages.reverse()
				this.setState({ activeJobsList: this.state.activeJobsList })
				toast.success('Job Deleted Successfully', this.toastStyle)
			} else {
				toast.error('Failed to delete Job', this.toastStyle)
			}
		}
	}
	handleLanguage = (selectedlang) => {
		const { selectedContentLanguages } = this.state
		const selectedLangIndex = selectedContentLanguages.findIndex((lang) => lang == selectedlang)

		if (selectedContentLanguages.includes(selectedlang)) {
			selectedContentLanguages.splice(selectedLangIndex, 1)
		} else {
			selectedContentLanguages.push(selectedlang)
		}
		this.setState({ selectedContentLanguages: selectedContentLanguages })
	}
	buttonVisibilityFunc = () => {
		const { selectedContentLanguages } = this.state
		const { approvedContentLanguages } = this.state.selectedContentId
		const checkContentInMultipleLanguage =
			this.state.selectedContentId.contentLanguages &&
				this.state.selectedContentId.contentLanguages.length > 1
				? true
				: false
		if (checkContentInMultipleLanguage) {
			const teluguContentApproved =
				approvedContentLanguages && approvedContentLanguages.includes('Te') ? true : false
			const checkTeluguSelected = selectedContentLanguages.includes('Te') ? true : false
			return teluguContentApproved ? selectedContentLanguages.length : checkTeluguSelected
		} else {
			return selectedContentLanguages.length
		}
	}
	checkContentCreatedInWordpress = () => {
		const { selectedContentId } = this.state
		let isContentInWordPress = false
		// if (selectedContentId.contentType == 'Story') {
		isContentInWordPress =
			selectedContentId.wordPressInfo &&
				Object.keys(selectedContentId.wordPressInfo).length > 0 &&
				selectedContentId.wordPressInfo.wordPressID
				? true
				: false
		// }
		return isContentInWordPress
	}
	renderApproveConfirmationModal = () => {
		const { approveModalVisible, selectedContentLanguages, selectedContentId } = this.state
		const contentSingleLanguageCondition =
			selectedContentId.contentLanguages &&
			selectedContentId.contentLanguages.length <= 1 &&
			selectedContentLanguages.length > 0

		let isContentInWordPress =
			selectedContentId.contentType != '' ? this.checkContentCreatedInWordpress() : false
		// let isStoryWithSocialMedia =
		//     selectedContentId.contentType == 'Story' ? this.checkContentHasSocialMedia() : false
		return (
			<Modal show={approveModalVisible} onHide={() => this.closeApproveModal()}>
				<Modal.Body>
					{selectedContentId.approvedContentLanguages ? (
						<div className='row'>
							<text>Content Approved In</text>
						</div>
					) : null}
					{selectedContentId.approvedContentLanguages &&
						selectedContentId.approvedContentLanguages.map((lang) => {
							return (
								<div className='row'>
									<text>{lang}</text>
								</div>
							)
						})}
					<div className='row'>
						<text> Approve Content In</text>
					</div>
					<div>
						{this.state.selectedContentId.contentLanguages &&
							this.state.selectedContentId.contentLanguages.map((language) => {
								return (
									<div>
										{this.state.selectedContentId.approvedContentLanguages ? (
											<div>
												{!this.state.selectedContentId.approvedContentLanguages.includes(
													language
												) ? (
													<div class='row'>
														<div class='col-md-1'>
															<input
																type='checkbox'
																onClick={() => this.handleLanguage(language)}
																checked={selectedContentLanguages.includes(language)}
															></input>
														</div>
														<div class='col-md-8'>
															<text for='text'> {language} </text>
														</div>
													</div>
												) : null}
											</div>
										) : (
											<div class='row'>
												<div class='col-md-1'>
													<input
														type='checkbox'
														onClick={() => this.handleLanguage(language)}
														checked={selectedContentLanguages.includes(language)}
													></input>
												</div>
												<div class='col-md-8'>
													<text for='text'> {language} </text>
												</div>
											</div>
										)}
									</div>
								)
							})}
					</div>
					<div>
						{isContentInWordPress ? (
							<div>
								<div>
									<text>This Content Is Also Created In telugu.yousay.tv</text>
								</div>

								<div>
									<text>This Content Will Also Be Published In telugu.yousay.tv</text>
								</div>

							</div>
						) : null}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={() => this.closeApproveModal()}>Cancel</Button>

					{contentSingleLanguageCondition || this.buttonVisibilityFunc() ? (
						<Button variant='primary' onClick={() => this.handleApprove()}>
							Ok
						</Button>
					) : (
						<Button disabled variant='secondary'>
							Ok
						</Button>
					)}
				</Modal.Footer>
			</Modal>
		)
	}
	handleApprove = async () => {
		const { selectedContentLanguages, selectedContentId } = this.state
		//  console.log(selectedContentId, 'selectedContentId')

		const input = {
			PK: selectedContentId.PK,
			SK: selectedContentId.SK,
			approveContentInLanguages: selectedContentLanguages,
			appInfoFrontEnd: {
				UUID: Auth.user.username,
				appVersionNumber: 62,
			},
			contentPublishedBy: this.state.loggedInUserID,
		}
		//  console.log(input, 'input')
		this.setState({ approveModalVisible: false, selectedContentLanguages: [] })
		const publishContentResponse = await PublishContent2Point0(input)
		if (publishContentResponse.statusCode == 'A270') {
			toast.success('Job Approved Successfully', this.toastStyle)

			this.refreshContents(selectedContentId.PK, selectedContentLanguages)
		} else {
			toast.error('Failed To Job Content', this.toastStyle)
		}
	}
	refreshContents = (contentID, selectedContentLanguages) => {
		const currentTime = Math.floor(Date.now() / 1000)
		const index = this.state.activeJobsList.findIndex(
			(item) => item.contentID == contentID
		)
		let refreshContentsList = this.state.activeJobsList
		if (this.state.activeJobsList[index].approvedContentLanguages != null) {
			this.state.activeJobsList[index].approvedContentLanguages.push(
				...selectedContentLanguages
			)
		} else {
			this.state.activeJobsList[index].approvedContentLanguages = selectedContentLanguages
		}
		if (this.state.activeJobsList[index].scheduledTime > currentTime) {
			this.state.activeJobsList[index].isScheduled = true
		}

		if (
			_.isEqual(
				_.sortBy(this.state.activeJobsList[index].approvedContentLanguages),
				_.sortBy(this.state.activeJobsList[index].contentLanguages)
			) &&
			this.state.activeJobsList[index].scheduledTime < currentTime
		) {
			refreshContentsList = this.state.activeJobsList.filter((data) => {
				return data.PK != contentID
			})
		}

		this.setState({ activeJobsList: refreshContentsList })
	}
	loadMore = async () => {
		await this.getNextActiveJobsLists()
	}
	// getActiveJobsExpiredList = async () => {
	// 	const { limit, filtered } = this.state

	//  console.log('inside getActiveJobsList')
	// 	const input = {
	// 		input: {
	// 			limit: this.state.limit,
	// 			nextToken: null,
	// 			contentStatus: this.state.expiredJobs?,
	// 			categoryType: "Jobs",
	// 			appInfoFrontEnd: {
	// 				appVersionNumber: 60,
	// 			},

	// 		}
	// 	}
	//  console.log(input, 'this is the input for expired jobs')
	// 	const contentsList = await GetListJobs(input)

	//  console.log(contentsList.items, 'here is the contents List in expired Jobs')
	// 	this.setState({

	// 		nextToken: contentsList.nextToken,
	// 		activeJobsList: contentsList.items,

	// 	})


	// }
	getActiveJobsList = async (search) => {
		this.setState({ loading: true })

		const {
			limit,
			selectionRange,
			filtered } = this.state


		const input = {
			input: {
				limit: this.state.limit,
				nextToken: null,
				contentStatus: this.state.expiredJobs ? 'expired' : 'published',
				categoryType: "Jobs",
				appInfoFrontEnd: {
					appVersionNumber: 60,
				},
				// fromTime: startTime,
				// toTime: endTime,


			}
		}
		// console.log(input, 'this is the limit of active jobs 478')
		if (filtered) {
			const { selectionRange, limit } = this.state
			const epochStartTime = selectionRange.startDate.getTime()
			const epochEndTime = selectionRange.endDate.getTime()
			const startTime = Math.trunc(epochStartTime / 1000)
			const endTime = Math.trunc(epochEndTime / 1000)
			input.input.fromTime = startTime
			input.input.toTime = endTime
		}
		// console.log(input, filtered, 'here is the list 488 ')
		const contentsList = await GetListJobs(input)
		console.log(contentsList, 'here is the contents List 490')


		const permissionInput = {
			mobileNumber: Auth.user.attributes.phone_number,
		}
		const userPermissions = await GetUserPermissions(permissionInput)
		let permissions = []
		let permissionsArr = []
		if (userPermissions && userPermissions.userRolesAndPermissions) {
			userPermissions.userRolesAndPermissions.map((item) => {
				permissions.push(...item.permissions)
			})
			permissions.map((permission) => {
				permissionsArr.push(permission.name)
			})
		}
		//  console.log(jobItems, 'here is the job items')

		this.setState({
			loggedInUserID: userPermissions.PK,
			nextToken: contentsList.nextToken,
			activeJobsList: contentsList.items,
			loggedInUserPermissions: permissionsArr,
			loading: false,
			render: true,
		})
	}
	getNextActiveJobsLists = async () => {
		const { limit, filtered } = this.state
		const input = {
			input: {
				limit: this.state.limit,
				nextToken: this.state.nextToken,
				contentStatus: this.state.expiredJobs ? 'expired' : 'published',
				categoryType: "Jobs",
				appInfoFrontEnd: {
					appVersionNumber: 60,
				},
			}
		}
		if (filtered) {
			const { selectionRange, limit } = this.state
			const epochStartTime = selectionRange.startDate.getTime()
			const epochEndTime = selectionRange.endDate.getTime()
			const startTime = Math.trunc(epochStartTime / 1000)
			const endTime = Math.trunc(epochEndTime / 1000)
			input.input.fromTime = startTime
			input.input.toTime = endTime
		}

		// console.log(input, 'input====')
		const data = await GetListJobs(input)

		console.log(data.items, 'data is')
		if (data.nextToken == null) {
			this.setState({
				activeJobsList: [...this.state.activeJobsList, ...data.items],
				nextToken: null,
			})
		} else {
			this.setState({
				activeJobsList: [...this.state.activeJobsList, ...data.items],
				nextToken: data.nextToken,
			})
		}
	}
	toggleShowExpiredJobs = () => {
		// console.log('inside this function')
		this.setState({ expiredJobs: !this.state.expiredJobs }, () => {
			this.getActiveJobsList()
		})

	}

	clearSearch = () => {
		this.setState({
			searchQuery: '',
			from: 0,
			searched: false,
			filtered: false,
			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: 'selection',
			},
			selectedFilterType: '',
		})
		this.getActiveJobsList()
	}
	// getActiveJobsList = async (search) => {
	// 	const input = {
	// 		search: search
	// 	}
	// 	const data = await GetContentsList(input)
	//  console.log(data.items, 'here is the dataaaaaaaaaaa')
	// 	this.setState({
	// 		activeJobsList: data.items
	// 	})

	//  console.log(data, 'datadatadatadatadata')
	// }
	onChangeSearch = (searchQuery) => {
		this.setState({ searchQuery: searchQuery })

	}
	search = () => {
		this.getSearchContents(this.state.searchQuery)
	}
	getSearchContents = async (search) => {
		const input = {

			from: parseInt(this.state.initialFromValue),
			limit: 3,
			filterBy: 'search',
			sortByOrder: 'desc'

		}
		if (this.state.selectedFilterType && this.state.selectedFilterType != '') {
			input['sortBy'] = this.state.selectedFilterType
		}
		if (this.state.searchQuery && this.state.selectedFilterType != '') {
			input['search'] = this.state.searchQuery
			input['sortBy'] = this.state.selectedFilterType
		}
		if (this.state.searchQuery) {
			input['search'] = this.state.searchQuery
		}



		// console.log(input, 'input firstt========')
		const searchResult = await SearchJobs(input)
		// console.log(searchResult, 'searchResult=====')

		this.setState({
			nextToken: searchResult.nextToken,
			totalSearchResultsCount: searchResult.total,
			activeJobsList: searchResult.items,
			searched: true,
			filteredExperienceRange: searchResult.filteredExperienceRange,
			filteredJobCategories: searchResult.filteredJobCategories,
			filteredJobMainLocations: searchResult.filteredJobMainLocations,
			filteredJobQualifications: searchResult.filteredJobQualifications,
			filteredJobRoles: searchResult.filteredJobRoles,
			filteredJobSkills: searchResult.filteredJobSkills,
			filteredJobSubLocations: searchResult.filteredJobSubLocations,
			filteredJobTypes: searchResult.filteredJobTypes,
			filteredSalaryRange: searchResult.filteredSalaryRange,
			filteredWorkTypes: searchResult.filteredWorkTypes,
		})

	}
	getNextSearchContents = async (type) => {
		const input = {

			limit: 2,
			filterBy: 'search',
			sortByOrder: 'desc',
			// from: this.state.initialLoadMore
			// 	? parseInt(this.state.from) + this.state.limit
			// 	: this.state.from,
			from: 3,
			nextToken: this.state.nextToken,

		}
		if (this.state.searchQuery) {
			input['search'] = this.state.searchQuery
		}
		// console.log(input, 'input firstt========')
		const searchResult = await SearchJobs(input)
		// console.log(searchResult, 'searchResult=====')

		this.setState({
			initialLoadMore: false,
			activeJobsList: searchResult.items
				? [...this.state.activeJobsList, ...searchResult.items]
				: [],
			from: this.state.initialLoadMore
				? parseInt(this.state.from) + this.state.limit + parseInt(this.state.limit)
				: parseInt(this.state.from) + this.state.limit,
			searched: true,
			totalSearchResultsCount: searchResult.total,
			filteredExperienceRange: searchResult.filteredExperienceRange,
			filteredJobCategories: searchResult.filteredJobCategories,
			filteredJobMainLocations: searchResult.filteredJobMainLocations,
			filteredJobQualifications: searchResult.filteredJobQualifications,
			filteredJobRoles: searchResult.filteredJobRoles,
			filteredJobSkills: searchResult.filteredJobSkills,
			filteredJobSubLocations: searchResult.filteredJobSubLocations,
			filteredJobTypes: searchResult.filteredJobTypes,
			filteredSalaryRange: searchResult.filteredSalaryRange,
			filteredWorkTypes: searchResult.filteredWorkTypes,
		})
	}
	openDatePicker = () => {
		this.setState({ showDatePicker: true })
	}
	handleSelect = (dates) => {
		const start = new Date(dates.selection.startDate)
		start.setHours(0, 0, 0, 0)
		const end = new Date(dates.selection.endDate)
		end.setHours(23, 59, 59, 999)

		const dateObj = {
			startDate: start,
			endDate: end,
			key: 'selection',
		}

		this.setState({ selectionRange: dateObj, showDatePicker: false, filtered: true })
	}

	getFormattedDate = (date) => {
		var dd = date.getDate()
		var mm = date.getMonth() + 1

		var yyyy = date.getFullYear()
		if (dd < 10) {
			dd = '0' + dd
		}
		if (mm < 10) {
			mm = '0' + mm
		}
		var formattedDate = dd + '/' + mm + '/' + yyyy
		var hh = date.getHours()
		var m = date.getMinutes()
		var d = 'AM'
		var h = hh
		if (h >= 12) {
			h = hh - 12
			d = 'PM'
		}
		if (h == 0) {
			h = 12
		}
		m = m < 10 ? '0' + m : m
		const formattedTime = h + ':' + m + ' ' + d
		// console.log(formattedDate, formattedTime, 'here is the formatted data')
		return formattedDate + ' ' + formattedTime
	}
	getPublishedDate = (time) => {
		const pubDate = new Date(time * 1000)
		const PublishedDate = this.getFormattedDate(pubDate)
		return PublishedDate
	}
	resetFilter = () => {
		this.setState({
			filtered: false,
			selectionRange: {
				startDate: new Date(),
				endDate: new Date(),
				key: 'selection',
			},
		}, () => this.getActiveJobsList())

	}
	renderTable = (heading, jobList) => {
		return (
			<Table striped bordered hover>
				<thead>
					<tr>
						{heading.map((head) => (
							<th class='unpublishedHeader'>
								{head}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{/* {console.log(jobList, 'here is the job listttttttt')} */}
					{jobList &&
						jobList.map(
							(row, index) => this.renderTableRow(row, index)
						)}
				</tbody>
			</Table>
		)
	}
	openDeleteModal = (item) => {
		this.setState({
			selectedContentId: item,
			deleteModalVisible: true,
		})
	}
	closeDeleteModal = (item) => {
		this.setState({
			selectedContentId: '',
			deleteModalVisible: false,
		})
	}
	openApproveModal = async (item) => {
		const input = {
			contentID: item.PK,
			loggedInUserID: Auth.user.username,
			appInfoFrontEnd: {
				appVersionNumber: 62,
			},
		}

		const data = await GetContent(input)
		this.setState({ selectedContentId: data, approveModalVisible: true })
	}
	closeApproveModal = (item) => {
		this.setState({ selectedContentId: '', approveModalVisible: false })
	}
	renderTableRow = (item, index) => {
		console.log(item, 'here is the jobdetails infooo')
		const deleteUnpublishedContents = this.state.loggedInUserPermissions.includes(
			DefinedPermissions['deleteUnpublishedContents']
		)
		const approveUnpublishedContentsPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions['approveUnpublishedContentsPermission']
		)
		const editUnpublishedContentsPermission = this.state.loggedInUserPermissions.includes(
			DefinedPermissions['editUnpublishedContentsPermission'])

		const currentTime = Math.trunc(new Date().getTime() / 1000)
		const PK = item.PK.replace('job#', '')
		// const PK = item.PK
		const { jobDetails } = item.contentMetaInfo
		// console.log(jobDetails, 'jobDetails===============')
		//  console.log(item.originalCreatorName, 'here is the meta infooo')
		//  console.log(item, 'here is the jobdetails infooo')
		const isContentInWordPress =
			item.wordPressInfo &&
				Object.keys(item.wordPressInfo).length > 0 &&
				item.wordPressInfo.wordPressID
				? true
				: false
		let wpPostURL = ''
		if (isContentInWordPress) {
			wpPostURL = item.wordPressInfo.wordPressPostURL
		}

		return (
			<tr>
				<td style={{ fontSize: '12px', maxWidth: '30px' }}>{index + 1}</td>
				<td>
					<div class='row d-flex justify-content-center align-items-center'>
						{editUnpublishedContentsPermission || true ? (

							<Link data-toggle='tooltip'
								title={`Edit Job`}
								// style={styles.fontSize}
								class='col-md-3 faIconClass'
								to={`/editJob?${PK}`} target='_blank'
							>
								<i class='fas fa-pencil-alt' />
							</Link>
						) : null}

						{deleteUnpublishedContents || true ? (
							<div
								data-toggle='tooltip'
								title={`Delete Content`}
								// style={styles.fontSize}
								class='col-md-3 faIconClass'
								onClick={() => {
									this.openDeleteModal(item)
								}}
							>
								<i class='fas fa-trash' />
							</div>
						) : null}
					</div>
				</td>
				<td style={{ fontSize: '12px', minWidth: '150px' }}>

					{item.contentCreatedDateTime && item.contentCreatedDateTime ? this.getPublishedDate(item.contentCreatedDateTime) : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '150px' }}>
					{item.contentPublishedDateTime && item.contentPublishedDateTime ? this.getPublishedDate(item.contentPublishedDateTime) : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>{this.getJobTitle(item)}</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{this.getJobDescription(item) ? (
						<div className='App'>
							<ReactReadMoreReadLess
								charLimit={50}
								readMoreText={'Read more ▼'}
								readLessText={'Read less ▲'}
								readMoreClassName='read-more-less--more'
								readLessClassName='read-more-less--less'
							>
								{this.getJobDescription(item)}
							</ReactReadMoreReadLess>
						</div>
					) : null}
				</td>
				<td style={{ fontSize: '12px', maxWidth: '30px' }}>{item.contentLanguage}</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{item.originalCreatorName && item.originalCreatorName != '' ? (
						<div>

							<text for='text'>CreatedBy : </text>
							<text>{item.originalCreatorName}</text>
						</div>)
						: null}

				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{item.originalCreatorName && item.originalCreatorName != '' ? (
						<div>

							<text for='text'>PublishedBy : </text>
							<text>{item.originalCreatorName}</text>
						</div>)
						: null}

				</td>

				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{jobDetails.experienceRange && jobDetails.experienceRange != '' ? (
						<div>

							<text for='text'>Experience : </text>
							<text>{jobDetails.experienceRange}</text>
						</div>)
						: null}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{jobDetails.salaryRange && jobDetails.salaryRange != '' ? (
						<div>

							<text for='text'>Salary : </text>
							<text>{jobDetails.salaryRange}</text>
						</div>)
						: null}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{jobDetails.jobMainLocation && jobDetails.jobSubLocation && jobDetails.jobMainLocation != '' && jobDetails.jobSubLocation != '' ? (
						<div>

							<text for='text'>Location : </text>
							<text>{jobDetails.jobMainLocation + '->' + jobDetails.jobSubLocation}</text>
						</div>)
						: null}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{jobDetails.noOfOpenings && jobDetails.noOfOpenings != '' && jobDetails.noOfOpenings != '0' ? (
						<div>

							<text for='text'>noOfOpenings : </text>
							<text>{jobDetails.noOfOpenings}</text>
						</div>)
						: '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{jobDetails.jobQualification && jobDetails.jobQualification != '' ? (
						<div>

							<text for='text'>Qualification : </text>
							<text>{jobDetails.jobQualification}</text>
						</div>)
						: null}
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{jobDetails.jobSkills && jobDetails.jobSkills?.length > 0 ? (
						<div>

							<text for='text'>Skills : </text>
							<text>{jobDetails.jobSkills}</text>
						</div>)
						: null}

				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>
					{item.PK && item.PK?.length > 0 ? (
						<div>

							<text for='text'> </text>
							<text>{item.PK}</text>
						</div>)
						: null}

				</td>





			</tr >
		)
	}
	getCompanyLogo = (item) => {
		let logo
		const {
			jobDetails

		} = item.contentMetaInfo
		const cdnurl = AwsConfig.cdn_url


		// const jobImage = jobDetails.jobImages?.length > 0 ? jobDetails.jobImages[0].image : this.generateImage(jobDetails)
		const jobImage = jobDetails.jobImages?.length > 0 ? jobDetails.jobImages[0].image : ""
		//  console.log(jobImage, "==============jobImage")
		logo = (jobImage && jobImage != '' && !jobImage.includes(cdnurl)) ? cdnurl + jobImage : jobImage

		//  console.log(logo, "====================logo")
		return logo
	}
	// generateImage = (details) => {
	//  console.log(details, "===================details")
	//     const imageData = GenerateImage({
	//         w: 300,
	//         h: 150,
	//         c: details.companyName && details.companyName != '' ? details.companyName.substring(0, 1) : ''
	//     });
	//     const buff = new Buffer(imageData)
	//     const base64data = buff.toString('base64')
	//     // src='data:image/svg+xml;base64,${base64data }'
	//  console.log(imageData, buff, base64data, "=============base64data")
	//     const finalImage = 'data:image/svg+xml;base64,' + base64data + "'"
	//  console.log(finalImage, '===========finalImage')
	//     // `data:image/svg+xml;utf8,${image}`
	//     return finalImage
	//     // return base64data
	// }
	getJobTitle = (item) => {
		// console.log(item, 'item========')
		let Title = ''

		const {
			jobDetails
		} = item.contentMetaInfo
		// console.log(jobDetails, 'here is the job details in active job')
		if (item.contentLanguages) {
			const lang = item.contentLanguages.includes('En') ? 'En' : 'Te'

			Title = jobDetails[`jobTitle_${lang}`] ? jobDetails[`jobTitle_${lang}`] : '-'
		}
		else {
			Title = jobDetails[`jobTitle`] ? jobDetails[`jobTitle`] : '-'
		}
		return Title
	}
	getJobDescription = (item) => {

		let Description = ''

		const {
			jobDetails
		} = item.contentMetaInfo
		// console.log(jobDetails, 'here is the job details')

		if (item.contentLanguages) {
			const lang = item.contentLanguages.includes('En') ? 'En' : 'Te'

			Description = jobDetails[`jobDescription_${lang}`] ? jobDetails[`jobDescription_${lang}`] : '-'
		}

		else {
			Description = jobDetails[`jobDescription`] ? jobDetails[`jobDescription`] : '-'
		}
		return Description
	}
	loadMoreContentsByType = async () => {
		const input = {

			from: 10,
			limit: 10,

			sortByOrder: 'asc',
			filterBy: 'jobAttributes',
			nextToken: this.state.nextToken,



		}


		if (this.state.selectedFilterType && this.state.selectedFilterType != '') {
			input['sortBy'] = this.state.selectedFilterType
		}


		// console.log(input, 'input firstt3333========')
		const typeBasedContents = await SearchJobs(input)
		// console.log(typeBasedContents, 'typeBasedContents=====')

		if (typeBasedContents.nextToken == null) {
			this.setState({
				activeJobsList: [...this.state.activeJobsList, ...typeBasedContents.items],
				nextToken: null,
			})
		} else {
			this.setState({
				activeJobsList: [...this.state.activeJobsList, ...typeBasedContents.items],
				nextToken: typeBasedContents.nextToken,
			})
		}
	}
	filterContentsByType = async () => {
		//if search pass filter by = 'search',if sort pass filter by= 'jobAttributes'
		const input = {

			from: 0,
			limit: 10,

			sortByOrder: 'desc',
			filterBy: 'jobAttributes',



		}

		// if (this.state.searchQuery && this.state.searchQuery != '') {
		// 	input['search'] = this.state.searchQuery


		// }
		if (this.state.selectedFilterType && this.state.selectedFilterType != '') {
			input['sortBy'] = this.state.selectedFilterType
		}
		// if (this.state.searchQuery && this.state.selectedFilterType != '') {
		// 	input['search'] = this.state.searchQuery
		// 	input['sortBy'] = this.state.selectedFilterType
		// }

		// console.log(input, 'input firstt222========')
		const typeBasedContents = await SearchJobs(input)
		// console.log(typeBasedContents, 'typeBasedContents=====')

		this.setState({
			nextToken: typeBasedContents.nextToken,

			activeJobsList: typeBasedContents.items,
		})
	}
	selectContentType = (item) => {
		// console.log(item, 'here is the log of this.state.selectedFilterType')
		this.setState({ selectedFilterType: item }, () => {
			this.filterContentsByType(this.state.selectedFilterType)
		})
	}

	// filterContentsByType = async ()=>{
	// 	const input = {
	// 		limit: 5,
	// 		nextToken: null,
	// 	}
	// 	if (this.state.selectedFilterType =='latestPostedJobs')
	// 	 {
	// 		input['sortBy'] = 'latestPostedJobs'
	// 		input['latestPostedJobs'] = this.state.selectedFilterType
	// 	} else {
	// 		input['sortBy'] = 'relevance'
	// 		input['relevance'] = this.state.selectedFilterType
	// 	}
	//  console.log(input,'input========')
	// }

	render() {
		const { headings, selectionRange, showDatePicker, activeJobsList, loading, filtered } = this.state
		//  console.log(filtered, "========renderactiveJobsList")
		return (
			<section className='feed'>
				{loading ?
					<Spinner /> : null
				}


				<div>
					<label>Active Jobs</label>
				</div>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>

				{/* <div> */}
				<div>
					<input
						type='text'
						onChange={(e) => {
							this.onChangeSearch(e.target.value)
						}}
						value={this.state.searchQuery}
						placeholder='Search Jobs'
					></input>
					<Button
						disabled={this.state.searchQuery ? false : true}
						style={{ marginRight: 10 }}
						onClick={() => {
							this.search()
						}}
					>
						Search
					</Button>
					<Button
						disabled={this.state.searchQuery ? false : true}
						style={{ marginRight: 10 }}
						onClick={() => {
							this.clearSearch()
						}}
					>
						Clear
					</Button>
				</div>
				{this.state.activeJobsList ?
					<div class='row'>
						<div class='col-md-4'>
							<text>Start Date : </text>
							<input
								type='text'
								onClick={() => {
									this.openDatePicker()
								}}
								value={this.getFormattedDate(selectionRange.startDate)}
								placeholder='Choose Start Date'
							></input>
						</div>

						<div class='col-md-4'>
							<text>End Date : </text>
							<input
								type='text'
								onClick={() => {
									this.openDatePicker()
								}}
								value={this.getFormattedDate(selectionRange.endDate)}
								placeholder='Choose End Date'
							></input>
						</div>

						<div class='filter-options'>
							<Button
								style={{ marginRight: 10 }}
								onClick={() => {
									this.getActiveJobsList()
								}}
							>
								Filter
							</Button>
							<Button
								onClick={() => {
									this.resetFilter()
								}}
							>
								Reset
							</Button>
						</div>
					</div> :
					<text>No Data to Display</text>}
				<div>
					<label>Sort By : </label>
					<br></br>
					<div>
						{this.state.contentsTypes.map((item) => (
							<div>
								<input
									type='radio'
									onClick={() => {
										this.selectContentType(item)
									}}
									checked={this.state.selectedFilterType == item}
								></input>
								<text>{item}</text>
							</div>
						))}
					</div>
					<div>
						<label>Show Expired Jobs</label>
						<div>
							<div>
								<input
									type='checkbox'
									onClick={() => { this.toggleShowExpiredJobs() }}
								// checked={this.state.showArchived}
								></input>
								<text>{'Expired Jobs'}</text>
							</div>
						</div>
					</div>
					{/* <div>
						<label>Active Jobs</label>
					</div> */}
					{this.state.searched ? (
						<div>
							<div class='row'>
								<div class='col-md-2'>
									<label>Experience Range</label>
									{this.state.filteredExperienceRange &&
										this.state.filteredExperienceRange.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})}
								</div>
								<div class='col-md-2'>
									<label>Job Categories </label>

									{this.state.filteredJobCategories

										? this.state.filteredJobCategories.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})
										: null}
								</div>
								<div class='col-md-2'>
									<label>Job MainLocations </label>

									{this.state.filteredJobMainLocations
										? this.state.filteredJobMainLocations.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})
										: null}
								</div>
								<div class='col-md-2'>
									<label>Job Qualifications </label>

									{this.state.filteredJobQualifications
										? this.state.filteredJobQualifications.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})
										: null}
								</div>
								<div class='col-md-2'>
									<label>Job Skills </label>

									{this.state.filteredJobSkills ? this.state.filteredJobSkills.map((item, index) => {
										return (
											<div>
												{item.key}-{item.doc_count}
											</div>
										)
									})
										: null}
								</div>
								<div class='col-md-2'>
									<label>Job SubLocations</label>

									{this.state.filteredJobSubLocations
										? this.state.filteredJobSubLocations.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})
										: null}
								</div>
								<div class='col-md-2'>
									<label>Job Types </label>

									{this.state.filteredJobTypes
										? this.state.filteredJobTypes.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})
										: null}
								</div>
								<div class='col-md-2'>
									<label>Salary Range </label>

									{this.state.filteredSalaryRange
										? this.state.filteredSalaryRange.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})
										: null}
								</div>
								<div class='col-md-2'>
									<label>Work Types </label>

									{this.state.filteredWorkTypes
										? this.state.filteredWorkTypes.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})
										: null}
								</div>
								<div class='col-md-2'>
									<label>Job Roles </label>

									{this.state.filteredJobRoles
										? this.state.filteredJobRoles.map((item, index) => {
											return (
												<div>
													{item.key}-{item.doc_count}
												</div>
											)
										})
										: null}
								</div>
							</div>
						</div>
					) : null}

				</div>
				<div>
					{showDatePicker ? (
						<DateRangePicker ranges={[selectionRange]} onChange={this.handleSelect} />
					) : null}
				</div>
				{this.state.activeJobsList && this.state.activeJobsList.length > 0 ? (

					<div style={{ marginTop: 10 }}>

						{this.renderTable(headings, activeJobsList)}
					</div>
					// </div>
				) : (
					<div>No Data To Display</div>
				)}
				{this.renderDeleteConfirmationModal()}
				{this.renderApproveConfirmationModal()}
				{!this.state.selectedFilterType &&
					this.state.activeJobsList &&
					this.state.activeJobsList.length > 0 &&
					!this.state.expiredJobs &&
					this.state.render &&
					this.state.nextToken != null &&
					!this.state.searchQuery && (
						<button onClick={this.loadMore} type='button' className='load-more'>
							Load more
						</button>
					)}

				{this.state.selectedFilterType && !this.state.nextToken != null && !this.state.searchQuery && (
					<button onClick={this.loadMoreContentsByType} type='button' className='load-more'>
						Load more
					</button>
				)}
				{this.state.activeJobsList &&
					this.state.activeJobsList.length > 0 &&
					this.state.render &&
					this.state.searchQuery &&
					this.state.activeJobsList.length < this.state.totalSearchResultsCount && (
						<button
							onClick={() => this.getNextSearchContents()}
							type='button'
							className='load-more'
						>
							Load more Results
						</button>
					)}
			</section>
		)
	}
}

export default activeJobs